module.exports = __webpack_public_path__ + "img/radio2.4feff4d3.png";